import React from 'react';
import HighlightCard from './HighlightCard';

export default function HighlightsList({ highlights }) {
  if (!highlights || highlights.length === 0) return null;
  return (
    <section style={styles.section}>
      <div style={styles.inner}>
        <span style={styles.eyebrow}>Das erwartet Sie</span>
        <h2 style={styles.heading}>Warum Camping Spirkenhof?</h2>
        <div style={styles.grid}>
          {highlights.map(h => (
            <HighlightCard key={h.id} icon={h.icon} title={h.title} text={h.text} />
          ))}
        </div>
      </div>
    </section>
  );
}

const styles = {
  section: {
    background: 'linear-gradient(180deg, #f0f7f2 0%, #e6f4eb 100%)',
    padding: '5rem 1.5rem',
  },
  inner: { maxWidth: '1100px', margin: '0 auto', textAlign: 'center' },
  eyebrow: { fontSize: '0.82rem', fontFamily: "'Nunito', Arial, sans-serif", fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: '#40916c' },
  heading: {
    color: '#1b4332',
    fontFamily: "'Nunito', Arial, sans-serif",
    fontSize: 'clamp(1.6rem,4vw,2.4rem)',
    fontWeight: '800',
    marginTop: '0.4rem',
    marginBottom: '2.5rem',
  },
  grid: { display: 'flex', flexWrap: 'wrap', gap: '1.5rem', justifyContent: 'center' },
};
